<ion-list mode="ios" lines="none" class="list-content">
  <ion-item lines="none" mode="md" color="transparent" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="mpe-font-weight-600 user-does-not-exist"
    >
      {{ 'Titles.user-does-not-exist' | translate }}
    </ion-label>
  </ion-item>

  <!-- ? Imagen -->
  <ion-item lines="none" mode="md" color="transparent">
    <ion-icon name="warning-outline" color="danger" class="warning"></ion-icon>
  </ion-item>

  <!-- * Descripción -->
  <ion-item lines="none" mode="md" color="transparent" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="phone-not-registered"
      [innerHTML]=" 'Labels.phone-not-registered' | translate | htmlSeguro"
    >
    </ion-label>
  </ion-item>

  <!-- ? Botones -->
  <ion-item-group>
    <!-- * Boton telefono -->
    <ion-item lines="none" mode="md" color="transparent" class="item-button">
      <ion-button
        size="default"
        mode="md"
        color="tpcta"
        (click)="onClick(true)"
      >
        <ion-label mode="md">
          {{ 'Buttons.change-phone' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>

    <!-- * Botone cuenta -->
    <ion-item lines="none" mode="md" color="transparent" class="item-button">
      <ion-button
        class="mpe-button-link-line"
        size="default"
        mode="md"
        fill="clear"
        color="darkblue"
        (click)="onClick(false)"
      >
        <ion-label mode="md">
          {{ 'Buttons.create-account' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>
  </ion-item-group>
</ion-list>
